// extracted by mini-css-extract-plugin
export default {"page":"ThankYou_page__MngwH"};